import { createAuthClient } from "better-auth/react";
import { magicLinkClient } from "better-auth/client/plugins";
import type { UiMode } from "@shared/schemas";

export const authClient = createAuthClient({
  // Same origin: SPA and API are served from the same Worker.
  baseURL: typeof window !== "undefined" ? window.location.origin : "",
  plugins: [magicLinkClient()],
});

export type SessionUser = {
  id: string;
  email: string;
  name: string | null;
  uiMode: UiMode;
};
